export const PageSpinner = () => {
  return (
    <div className="flex h-[80vh] w-full items-center justify-center">
      <div className="lds-ellipsis text-black dark:text-white">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};
